import React from "react";
const NumberFormat = ({ value }) => {
  if (!value) {
    return null;
  }
  let formatedValue = Number(value).toLocaleString("fa-IR");
  return (
    <span>
      {formatedValue}
      <span className="currency">ریال</span>
    </span>
  );
};
export default NumberFormat;
